import { render, staticRenderFns } from "./BillingMobile.vue?vue&type=template&id=bde35750&scoped=true"
import script from "./BillingMobile.vue?vue&type=script&lang=js"
export * from "./BillingMobile.vue?vue&type=script&lang=js"
import style0 from "./BillingMobile.vue?vue&type=style&index=0&id=bde35750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde35750",
  null
  
)

export default component.exports